module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"transactions":"No transaction| {n} transaction | {n} transactions"}}')
  delete Component.options._Ctor
}
